import Checkbox, { type Props as CheckboxProps } from '@components/Checkbox';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';

interface Props extends CheckboxProps {
    onClick?: () => void;
    required?: boolean;
}

function CheckboxLI(props: Props) {
    const {
        isChecked, toggleCheckbox, children, onClick, required,
    } = props;
    return (
        <Container aria-label='check-box-list-item'
            onClick={onClick}>
            <CheckboxWrapper>
                <Checkbox isChecked={isChecked}
                    toggleCheckbox={toggleCheckbox}>
                    {children}
                    {required && <Required>*</Required>}
                </Checkbox>
            </CheckboxWrapper>
            <ArrowLineRight size={16} color='var(--color-gray7)'/>
        </Container>
    );
}

const Container = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: var(--spacing-2) 0;
    width: 100%;

    [aria-label='checkbox'] {
        width: auto;
    }
`;

const Required = styled.span`
    color: inherit;
`;

const CheckboxWrapper = styled.div`
    flex: 1;
`;

export default CheckboxLI;
